import VideoShareContainer from "./VideoShareContainer";

export default VideoShareContainer;
